import { useEffect, useState } from "react";
import Form from "react-validation/build/form";
import Select from "react-validation/build/select";
import GroupService from "../../services/groups.service";

const GroupSelectField = ({
  label,
  name,
  onChange,
  value,
  disabled,
  groupId,
}) => {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    (async () => {
      if (groupId) {
        const optionData = await GroupService.getOptions(groupId);
        setOptions(optionData);
      }
    })();
  }, [groupId]);

  return (
    <Form>
      <div className="col">
        <label className="capitalize">
          <strong>{label}</strong>
        </label>
        <Select
          className="form-control"
          name={name}
          onChange={onChange}
          value={value}
          disabled={disabled}
        >
          <option value="">Seleccione</option>
          {options &&
            options.map((f) => (
              <option
                key={`user-group-${f.value}`}
                value={f.value}
                className="capitalize"
              >
                {f.text}
              </option>
            ))}
        </Select>
      </div>
    </Form>
  );
};

export default GroupSelectField;
